/* eslint-disable no-console */
import { Configuration, LogLevel } from '@azure/msal-browser';
import { ENV } from 'config';
import { APP_ROUTES } from 'shared/constants';

const envConfig = {
    clientId: ENV.B2C_CLIENT_ID,
    tenantName: ENV.B2C_TENANT_NAME,
    customDomain: ENV.B2C_CUSTOM_DOMAIN,
    isProd: ENV.NODE_ENV === 'production'
};

const AZURE_AUTH_APP_B2C_SCOPE = `https://${ envConfig.tenantName }.onmicrosoft.com/${ envConfig.clientId }/User.Normal`;
const AZURE_B2C_TENANT_NAME = envConfig.customDomain || `${ envConfig.tenantName }.b2clogin.com`;

export const AUTH_SCOPES = [ 'openid', AZURE_AUTH_APP_B2C_SCOPE ];

export const msalConfig: Configuration = { 
    auth: {
        clientId: envConfig.clientId,
        authority: getAuthorityByPolicyName('B2C_1A_UniversalUserEntry'),
        knownAuthorities: [
            AZURE_B2C_TENANT_NAME,
            'login.microsoftonline.com'
        ],
        redirectUri: `${ window.location.origin }${ APP_ROUTES.basename }`
    },
    cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: false
    },
    system: {
        loggerOptions: {
            logLevel: envConfig.isProd ? LogLevel.Error : LogLevel.Info,
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }

                switch (level) {
                    case LogLevel.Error:
                        console.error(message);

                        return;
                    case LogLevel.Info:
                        console.info(message);

                        return;
                    case LogLevel.Verbose:
                        console.debug(message);

                        return;
                    case LogLevel.Warning:
                        console.warn(message);

                        return;
                }
            }
        }
    }
};

export function getAuthorityByPolicyName(policyName: string): string {
    return `https://${ AZURE_B2C_TENANT_NAME }/${ envConfig.tenantName }.onmicrosoft.com/${ policyName }`;
}
